import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import { Upload } from "../../Pages/Items/Reducers/items/actions";

const UploadForm = ({ label, Upload, onClose, input, isModal, minSize }) => {
  const [disabled, setDisabled] = useState(true);
  const [files, setFiles] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState({});
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [currentFileIndex, setCurrentFileIndex] = useState(0);

  useEffect(() => {
    if (input.value && input.value.length > 0) {
      const updatedFiles = input.value.map((file) => {
        if (file && file.thumbnail && file.thumbnail.small) {
          return {
            ...file, // Kopieer alle eigenschappen van het bestaande bestand
            preview: file.thumbnail.small, // Voeg de preview eigenschap toe
          };
        }
        return file;
      });

      setFiles(updatedFiles); // Update de state met de nieuwe array
    }
  }, [input.value]);

  const onDrop = (newFiles, rejectedFiles) => {
    let errors = {};
    setNewFiles(
      newFiles.map((f) =>
        Object.assign(f, {
          preview: URL.createObjectURL(f),
        })
      )
    );
    setErrors(errors);
  };

  const handleUpload = async () => {
    if (newFiles.length === 0) return;

    try {
      setIsUploading(true);
      setUploadProgress(0);
      setErrors({});
      setSuccess({});

      const result = [...files];

      for (let index = 0; index < newFiles.length; index++) {
        setCurrentFileIndex(index + 1);
        const file = newFiles[index];

        // Simulate progress for individual file upload
        const progressIncrement = 100 / newFiles.length;
        const baseProgress = index * progressIncrement;

        // Simulate upload progress steps
        for (let i = 0; i <= 10; i++) {
          setUploadProgress(baseProgress + (progressIncrement * i / 10));
          await new Promise(resolve => setTimeout(resolve, 50));
        }

        const data = await Upload({ file });

        if (data.type === "ITEM_ERROR") {
          const newErrors = { message: data.payload };
          setErrors(newErrors);
          setIsUploading(false);
          setUploadProgress(0);
          return true;
        } else {
          result.push(data);
        }

        setUploadProgress((index + 1) * progressIncrement);
      }

      input.onChange(result);
      setNewFiles([]);
      setUploadProgress(100);
      setSuccess({ message: "Uploaden is gelukt" });

      // Reset progress after a delay
      setTimeout(() => {
        setIsUploading(false);
        setUploadProgress(0);
        setCurrentFileIndex(0);
        if (isModal) onClose();
      }, 1000);

    } catch (e) {
      console.error('Upload failed:', e);
      setErrors({ message: "Er is een fout opgetreden tijdens het uploaden" });
      setIsUploading(false);
      setUploadProgress(0);
      setCurrentFileIndex(0);
    }
  };
  const handleDelete = (index) => {
    setFiles((prevFiles) => prevFiles.filter((file, i) => i !== index));
  };
  return (
    <div>
      <label>{label}</label>
      <div>
        <Dropzone onDrop={onDrop} minSize={minSize? minSize : 0} disabled={isUploading}>
          {({ getRootProps, getInputProps }) => (
            <section
              style={{
                minHeight: "100px",
                borderWidth: "2px",
                borderColor: isUploading ? "#ccc" : "rgb(102, 102, 102)",
                borderStyle: "dashed",
                borderRadius: "5px",
                display: "inline-block",
                width: "100%",
                backgroundColor: isUploading ? "#f8f9fa" : "transparent",
                opacity: isUploading ? 0.6 : 1,
                cursor: isUploading ? "not-allowed" : "pointer",
              }}
            >
              <div
                style={{
                  minHeight: "100px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                {...getRootProps()}
              >
                <input {...getInputProps()} />
                <p style={{ textAlign: "center", margin: 0, color: isUploading ? "#999" : "#333" }}>
                  {isUploading ? "Uploaden..." : "Kies je bestand of sleep hem hier naar toe"}
                </p>
              </div>
            </section>
          )}
        </Dropzone>
        <ul className="users-list clearfix">
          {newFiles.map((f, index) => (
            <li key={index} style={{ display: 'inline-block', margin: '10px', position: 'relative', width: '120px' }}>
              <button type="button" className="close" onClick={() => handleDelete(index)} aria-label="Close" style={{ position: 'absolute', top: '5px', right: '5px', zIndex: 10, background: 'rgba(255,255,255,0.8)', border: 'none', borderRadius: '50%', width: '20px', height: '20px', fontSize: '12px' }}>
                <span aria-hidden="true">×</span>
              </button>
              <img src={f.preview} alt="Afbeelding" style={{ width: '100px', height: '75px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #ddd' }} />
              <span className="users-list-date" style={{ display: 'block', fontSize: '11px', marginTop: '5px', textAlign: 'center', wordWrap: 'break-word' }}>{f.name}</span>
            </li>
          ))}
        </ul>
        {!isModal && (
          <ul className="users-list clearfix">
            {files.map((f, index) => (
              <li key={index} style={{ display: 'inline-block', margin: '10px', position: 'relative', width: '120px' }}>
                <button type="button" className="close" onClick={() => handleDelete(index)} aria-label="Close" style={{ position: 'absolute', top: '5px', right: '5px', zIndex: 10, background: 'rgba(255,255,255,0.8)', border: 'none', borderRadius: '50%', width: '20px', height: '20px', fontSize: '12px' }}>
                  <span aria-hidden="true">×</span>
                </button>
                <img src={f.preview} alt="Afbeelding" style={{ width: '100px', height: '75px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #ddd' }} />
                <span className="users-list-date" style={{ display: 'block', fontSize: '11px', marginTop: '5px', textAlign: 'center', wordWrap: 'break-word' }}>{f.name}</span>
              </li>
            ))}
          </ul>
        )}
        {/* Upload Progress */}
        {isUploading && (
          <div style={{ marginBottom: '15px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
              <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                Uploaden... ({currentFileIndex}/{newFiles.length})
              </span>
              <span style={{ fontSize: '12px', color: '#666' }}>
                {Math.round(uploadProgress)}%
              </span>
            </div>
            <div style={{
              width: '100%',
              height: '8px',
              backgroundColor: '#e9ecef',
              borderRadius: '4px',
              overflow: 'hidden'
            }}>
              <div
                style={{
                  width: `${uploadProgress}%`,
                  height: '100%',
                  backgroundColor: '#28a745',
                  transition: 'width 0.3s ease',
                  borderRadius: '4px'
                }}
              />
            </div>
          </div>
        )}

        {errors && <div className="text-danger">{errors.message}</div>}
        {success && <div className="text-success">{success.message}</div>}
        <input
          type="button"
          onClick={handleUpload}
          className="btn btn-next btn-fill btn-success btn-wd btn-sm"
          value={isUploading ? "Uploaden..." : "Uploaden"}
          disabled={isUploading || newFiles.length === 0}
        />
      </div>
    </div>
  );
};

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, { Upload })(UploadForm);
